export const getBSCornmealPackage = newProduct => {
  const newBSCornmealPackage = {
    UPC: newProduct.UPC,
    Size: newProduct.Size,
    FDACert: newProduct.FDACert,
    Organic: newProduct.Organic,
  }
  return newBSCornmealPackage
}

export const updateBSCornmealPackage = newProduct => {
  const newBSCornmealPackage = {
    UPC: newProduct.UPC,
    Size: newProduct.Size,
    FDACert: newProduct.FDACert,
    Organic: newProduct.Organic,
  }
  return newBSCornmealPackage
}
